module.exports = __webpack_public_path__ + "img/main_sub_card_auto.d0686355.png";